const SHOP_ITEM_DATA = [
  {
    item_image:
      "https://user-images.githubusercontent.com/60150901/119376509-a78ea280-bcd9-11eb-8235-cbede817809a.jpg",
    item_name: "JOGGERS - BLACK",
    item_price: "$24.99",
  },
  {
    item_image:
      "https://user-images.githubusercontent.com/60150901/119376506-a65d7580-bcd9-11eb-9405-3c8bb6a07f62.jpg",
    item_name: "JOGGERS - GREY",
    item_price: "$34.99",
  },
  {
    item_image:
      "https://user-images.githubusercontent.com/60150901/119376504-a5c4df00-bcd9-11eb-8e73-688133064873.jpeg",
    item_name: "BLACK LONG SLEEVE",
    item_price: "$30.99",
  },
  {
    item_image:
      "https://user-images.githubusercontent.com/60150901/119376496-a3628500-bcd9-11eb-8796-a6b78cb683a8.jpg",
    item_name: "BLACK TEE'S",
    item_price: "$24.5",
  },
  {
    item_image:
      "https://user-images.githubusercontent.com/60150901/119376489-a1002b00-bcd9-11eb-9d2f-50df941f4999.png",
    item_name: "WEIGHT VESTS",
    item_price: "$44.99",
  },
  {
    item_image:
      "https://user-images.githubusercontent.com/60150901/119377820-2afcc380-bcdb-11eb-807e-bbe14b157e65.jpg",
    item_name: "STRENGTH WRIST WRAP",
    item_price: "$14.99",
  },
  {
    item_image:
      "https://user-images.githubusercontent.com/60150901/119377829-2df7b400-bcdb-11eb-9898-691ece065785.jpg",
    item_name: "PARALLETTES",
    item_price: "$20.99",
  },
];

export default SHOP_ITEM_DATA;
